import APIConfiguration from '@savgroup-front-common/configuration/api';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import {
  ApiRequestDescriptor,
  executeQuery,
} from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.carrier}sellers/${COMMON_QUERY_PARAMS.SELLER_ID}/carriers/accounts`;

export interface CarrierAccountSummary {
  id: string;
  carrier: string;
  name?: string;
}

export interface GetCarrierAccountsBySellerQueryArgs {
  sellerId: string;
}

export const getCarrierAccountsBySellerRequest = ({
  sellerId,
}: GetCarrierAccountsBySellerQueryArgs): ApiRequestDescriptor => ({
  url: ENDPOINT.replace(COMMON_QUERY_PARAMS.SELLER_ID, sellerId),
  config: { method: SUPPORTED_METHODS.GET },
});

export async function getCarrierAccountsBySellerQuery(
  payload: GetCarrierAccountsBySellerQueryArgs,
): Promise<BackResponse<CarrierAccountSummary[]> | BackResponseFailure> {
  try {
    return await executeQuery<BackResponse<CarrierAccountSummary[]>>(
      getCarrierAccountsBySellerRequest(payload),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
}
